<script module lang="ts">
	export type IconName =
		| 'brush'
		| 'bullhorn'
		| 'chevron-down'
		| 'chevron-up'
		| 'chevron-right'
		| 'code'
		| 'copy'
		| 'cross'
		| 'cubes'
		| 'external'
		| 'file'
		| 'fold'
		| 'github'
		| 'layers'
		| 'menu'
		| 'minimize'
		| 'moon'
		| 'network'
		| 'rss'
		| 'sun'
		| 'swap'
		| 'target'
		| 'twitter'
		| 'warning'
</script>

<script lang="ts">
	interface Props {
		size?: number
		color?: string
		name: IconName
	}

	let { size = 24, color = '', name }: Props = $props()
</script>

<svg width={size} height={size} class={[color, 'icon']} aria-hidden="true" fill-rule="evenodd">
	<use xlink:href="#svg--{name}" />
</svg>

<style>
	.icon {
		display: inline-block;
		fill: currentColor;
	}
</style>
